export default [
  {
    header: "კლიენტები",
  },
  {
    title: "ინდექს პაციენტები",
    route: "index-patients",
    icon: "OctagonIcon",
  },
  {
    title: "კონტაქტები",
    route: "contacts",
    icon: "UsersIcon",
  },
  {
    title: "რისკ-ჯგუფები",
    route: "risk-groups",
    icon: "AlertTriangleIcon",
  },
]
